import { Component, Input, OnInit } from '@angular/core';
import { EdlItemPacketStatus } from 'src/app/model/enum/item-packet/edl-item-packet-status.enum';
import { EdlIpPillDTO } from 'src/app/model/item-packet/edl-ip-pill-dto.model';
import { EdlItemPacketEntryDTO } from 'src/app/model/item-packet/edl-item-packet-entry.model';
import { EdlItemPacketUserSummaryDTO } from 'src/app/model/item-packet/edl-item-packet-user-summary-dto.model';

@Component({
    selector: 'item-packet-pills',
    templateUrl: './item-packet-pills.component.html',
    styleUrls: ['./item-packet-pills.component.scss']
})
export class ItemPacketPillsComponent implements OnInit {
    private _entries: EdlItemPacketEntryDTO[] = [];
    private _userEntries: EdlItemPacketUserSummaryDTO[] = [];
    private _filterStatuses: EdlItemPacketStatus | EdlItemPacketStatus[] | null = null;

    @Input() set entries(value: EdlItemPacketEntryDTO[]) {
        this._entries = value;
        this.updateFilteredEntries();
    }
    get entries(): EdlItemPacketEntryDTO[] {
        return this._entries;
    }

    @Input() set userEntries(value: EdlItemPacketUserSummaryDTO[])
    {
        this._userEntries = value;
        this.updateFilteredUserEntries(value);
    }
    get userEntries(): EdlItemPacketUserSummaryDTO[] {
        return this._userEntries;
    }

    @Input() pills: EdlIpPillDTO[] = [];
    @Input() set filterStatuses(value: EdlItemPacketStatus | EdlItemPacketStatus[] | undefined | null) {
        this._filterStatuses = value;
        this.updateFilteredEntries();
        this.updateFilteredUserEntries(this.userEntries);
    }

    get filterStatuses(): EdlItemPacketStatus | EdlItemPacketStatus[] | undefined | null {
        return this._filterStatuses;
    }

    @Input() showTitle: boolean = false;
    @Input() isVertical: boolean = false;


    public filteredEntries: EdlItemPacketEntryDTO[] = [];
    public filteredUserEntries: EdlItemPacketUserSummaryDTO[] = [];

    ngOnInit(): void {
        this.updateFilteredEntries();
        this.updateFilteredUserEntries(this.userEntries);
    }


    private updateFilteredEntries() {
        this.filteredEntries = this.entries?.filter(entry => this.canShowPill(entry.Status)) ?? [];
    }

    private updateFilteredUserEntries(entries: EdlItemPacketUserSummaryDTO[]) {
        this.filteredUserEntries = this.userEntries?.filter(entry => this.canShowPill(entry.Packet.Status)) ?? [];
    }

    private canShowPill(status: EdlItemPacketStatus): boolean {
        return this.filterStatuses === null 
            || this.filterStatuses === undefined
            || (Array.isArray(this.filterStatuses) ? 
                (this.filterStatuses.length == 0 || this.filterStatuses.includes(status)) : 
                this.filterStatuses === status
            );    
    }
}
